import { Notification_ReadState } from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/notification_pb';
import { CATEGORY_TO_TYPE } from './utils/categoryMapping';

export type NotificationUrgency = 'high' | 'mid' | 'none';

export type UrgencyMessageKey = 'high' | 'mid';

export interface UrgencyStyle {
  iconBgColor: string;
  iconColor: string;
  urgencyMessageKey?: UrgencyMessageKey;
  urgencyBgColor?: string;
  urgencyBorderColor?: string;
  urgencyTextColor?: string;
}
export interface ParsedNotification {
  title: string;
  deviceTitle: string;
  roomTitle: string;
  alertDescription: string;
  stepsToPerform: string;
  date: string;
  resolvedDate?: string;
  urgency: NotificationUrgency;
  roomId: string;
  deviceName: string;
  readState: Notification_ReadState;
  name: string;
  category: NotificationIconType;
  categoryRawType: keyof typeof CATEGORY_TO_TYPE;
  categoryLabel: string;
  isResolved: boolean;
}

export type NotificationIconType =
  | 'alert'
  | 'reminder'
  | 'solved'
  | 'news'
  | 'updates'
  | 'notification';

export enum NotificationTypes {
  ALERT = 'alert',
  REMINDER = 'reminder',
  SOLVED = 'solved',
  NEWS = 'news',
  UPDATES = 'updates',
  NOTIFICATION = 'notification',
}
